import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import Select from 'react-select'

const FeaturesList = [
  { label: 'Apps', value: 'Apps' },
  { label: 'Media Library', value: 'Media Library' },
  { label: 'Check List', value: 'Check List' },
  { label: 'Change Log', value: 'Change Log' },
  { label: 'Knowledge base', value: 'Knowledge base' },
  { label: 'White Board', value: 'White Board' },
  { label: 'Saas Configurator', value: 'Saas Configurator' },
  { label: 'Stripe Connection', value: 'Stripe Connection' },
]

const CreateModal = ({ handleRefresh }) => {
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [features, setFeatures] = useState([])

  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    const payload = {
      name: e.target.name.value,
      features: features,
    }

    const { response } = await AppService.partner_keys.create({ payload })

    if (response) {
      setProcessing(false)
      closeAddProduct()
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
        <MDButton color="white" variant="contained" onClick={handleModal}>
          Create
        </MDButton>
      </div>

      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Key
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>
            <MDBox mb={2} sx={{ fontSize: '14px' }}>
              <MDTypography variant="button">Features</MDTypography>
              <Select
                isMulti
                options={FeaturesList}
                name="features"
                onChange={(e) => setFeatures(e)}
              />
            </MDBox>
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
